import axiosClient from "api/axios_client.js"; 

const apiTradeOfWorkDirectory = {
   create: (payload) => axiosClient.post(`/directories/business-master/trade-of-work/create`, payload),
  update: (id, payload) => axiosClient.put(`/directories/business-master/trade-of-work/update/${id}`, payload),
  getById: (id) => axiosClient.get(`/directories/business-master/trade-of-work/get-by-id/${id}`),
  updateStatus: (payload) => axiosClient.post(`/directories/business-master/trade-of-work/update-status`, payload),

  delete: (ids) => axiosClient.delete(`/directories/business-master/trade-of-work/delete`, {data: {ids}}),
};

export default apiTradeOfWorkDirectory;


